/*
 * AdminSettings Messages
 *
 * This contains all the text for the AdminSettings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  settings: {
    id: 'app.common.settings',
    defaultMessage: 'Settings',
  },
  schoolDetails: {
    id: 'app.components.AdminSettings.schoolDetails',
    defaultMessage: 'School Details',
  },
  colorsLogoTagline: {
    id: 'app.components.AdminSettings.colorsLogoTagline',
    defaultMessage: 'Colors, Logo and Tagline',
  },
  language: {
    id: 'app.common.language',
    defaultMessage: 'Language',
  },
  other: {
    id: 'app.common.other',
    defaultMessage: 'Other',
  },
  schoolManagers: {
    id: 'app.components.AdminSettings.schoolManagers',
    defaultMessage: 'School Managers',
  },
  schools: {
    id: 'app.components.AdminSettings.schools',
    defaultMessage: 'Schools',
  },
  adminEmployees: {
    id: 'app.components.AdminSettings.adminEmployees',
    defaultMessage: 'Administrative Employees',
  },
  leadAuthors: {
    id: 'app.components.AdminSettings.leadAuthors',
    defaultMessage: 'Lead Authors',
  },
  keyUsers: {
    id: 'app.components.AdminSettings.keyUsers',
    defaultMessage: 'Key Users',
  },
  schoolManagersIntro: {
    id: 'app.components.AdminSettings.schoolManagersIntro',
    defaultMessage: 'Managers can use all features in the dashboard.{br}Managers can view standard messages in all groups and send messages to all groups.',
  },
  adminIntro: {
    id: 'app.components.AdminSettings.adminIntro',
    defaultMessage: 'Administrative employees can use all features in the dashboard.',
  },
  leadIntro: {
    id: 'app.components.AdminSettings.leadIntro',
    defaultMessage: 'Users listed below have permissions to write messages to all groups and start conversations with all users of all groups without being a member of those groups.',
  },
  specificUsers: {
    id: 'app.components.AdminSettings.specificUsers',
    defaultMessage: 'Specific users in your school with the same permissions:',
  },
  allEmployees: {
    id: 'app.components.AdminSettings.allEmployees',
    defaultMessage: 'All employees',
  },
  confirmRemoveUser: {
    id: 'app.components.AdminSettings.confirmRemoveUser',
    defaultMessage: 'Remove user {accountName}?',
  },
  addKeyUsers: {
    id: 'app.components.AdminSettings.addKeyUsers',
    defaultMessage: 'Add {type}',
  },
  noUsers: {
    id: 'app.components.AdminUsers.noUsers',
    defaultMessage: 'No users',
  },
  subschoolsIntro: {
    id: 'app.components.AdminSettings.subschoolIntro',
    defaultMessage: '{count, plural, one {# school is} other {# schools are}} connected. Contact support to connect more schools or to remove connections.',
  },
});
